import React, {useEffect} from 'react';
import Chat from './Chat';
import Phone from './img/phone.svg';
import DevBox from './Components/DevBox';
import DevInfo from './Components/DevInfo';
import InfoImg from './img/SVG/phone.svg';
import InfoImg1 from './img/website-info2.png';
import Aos from 'aos';
import "aos/dist/aos.css";

function Applications() {

    useEffect(() => {
        Aos.init({ duration: 700,
            delay:200});
    }, [])

    return (
        <div className="websites">
            <div className="website-hero-bg"/>      
            <div className="website-hero-white"/>      
            <div className="website-hero"  data-aos="fade-up">
                <div className="website-hero-text">
                    <h1>APP</h1>
                    <h1>DEVELOPMENT</h1>
                </div>
                <img src={Phone}/>
            </div>    
            <div className="website-benifits">
                <DevBox title="Qaulity Guarentee" text="We're that confident that you'll be happy with our work."/>
                <DevBox title="5% Late Penalty" text="We will credit you 5% off orders that go over schedule."/>
                <DevBox title="1 Year Support" text="Hopefully you won't need us, however if you do we're here."/>
            </div>

            <div className="website-info">

                <DevInfo direction="devinfo-left"
                 img={InfoImg}
                title="ANDROID, IOS or HYBRID APP"
                 text="Whatever your requirements are, we can cater. Our developers develop apps our apps in either Flutter ( Hybrid ), Java ( Android ) and Swift ( IOS ) - all dependent on your reuqirements. Our apps are built with premuim quality, industry level code practice and latest API/SDK supports in given time frame.
                 " />
                <DevInfo direction="devinfo-right"
                 img={InfoImg1}
                title="CUSTOM FEATURES"
                 text="We can develop custom APIs or SDKs for your requirements and hardware. We don't just cater for standard apps but also customly built software for data-processing hardware and scanners. If you want to learn more about this, don't hesitate to contact us below." />
            </div>
            <Chat/>
        </div>
    )
}

export default Applications
